"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQuickBuyColor = exports.Markets = void 0;
let Markets = exports.Markets = /*#__PURE__*/function (Markets) {
  Markets["CN"] = "cn";
  return Markets;
}({});
const getQuickBuyColor = ({
  tenant,
  disabled,
  theme
}) => {
  if (disabled) {
    return theme.palette.action.disabled;
  }
  return tenant === Markets.CN ? theme.palette.superApp.main : theme.palette.text.primary;
};
exports.getQuickBuyColor = getQuickBuyColor;
